import { observer } from 'mobx-react';
import React from 'react';
import { DatePicker } from 'material-ui';
import PropTypes from 'prop-types';

import moment from 'moment';
import _ from 'lodash';

export const WizDatePicker = observer(({
  name,
  disabled = false,
  shouldDisableDate,
  disableYearSelection,
  placeholder = 'Select Date',
  fullWidth = false,
  container,
  mode,
  maxDate,
  minDate,
  value,
  autoOk = true,
  onChange,
  required = false,
}) => {

  const formatDate = (date) => {
    if (_.isNaN(value)) {
      throw new Error(`toShortDate: ${value} is not a number`)
    }

    return ((value) ? moment(value).format('DD.MM.YYYY') : '-')
  };

  const utcOnChange = (e, v) => {
    const d = new Date(v);
    const utcDate = new Date(Date.UTC(d.getFullYear(),d.getMonth(),d.getDate()));

    return onChange(e, utcDate);
  };

  const datePickerProps = {
    name,
    disabled,
    shouldDisableDate,
    disableYearSelection,
    placeholder,
    fullWidth,
    container,
    maxDate,
    minDate,
    mode,
    value,
    autoOk,
    onChange: utcOnChange,
    required,
    formatDate
  };

  return (
    <div >
      <DatePicker { ...datePickerProps }/>
    </div>
  );
});

WizDatePicker.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  autoOk: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
};




// WEBPACK FOOTER //
// ./src/components/wiz-date-picker/wiz-date-picker.js